import { Button } from '@factorialco/deprecated-design-system'
import { truncate } from 'lodash'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { Step } from 'modules/processes/domain'
import { useDestroyStep } from 'modules/processes/hooks/useDestroyStep'

interface Props {
  onClose: () => void
  processId: string
  step: Step
}

const DeleteStepConfirmationModal = ({ step, onClose, processId }: Props) => {
  const { destroyStep } = useDestroyStep()
  const { performAction, running } = useAsyncAction(async () => {
    if (!step.id) return

    destroyStep(step.id, processId)
    onClose()
  })

  return (
    <Modal
      title={i18n.t('processes.process_settings.steps.delete_modal.title', {
        name: truncate(step.name),
      })}
      description={i18n.t('processes.process_settings.steps.delete_modal.description', {
        name: truncate(step.name),
      })}
      illustration="delete"
      onClose={onClose}
      onSubmit={performAction}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="negative" disabled={running} submit>
            {i18n.t('processes.process_settings.steps.delete_modal.delete')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteStepConfirmationModal
